import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { httpsCallable } from 'firebase/functions';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, functions } from '../../services/firebase';

// Componentes do Kiosk — renderizados diretamente após autenticação
// para evitar passar pelo AuthorizedRoute (que pode redirecionar para /home)
import KioskPage from './index';
import TVDisplay from './TVDisplay';
import WorkoutPrintScreen from './WorkoutPrintScreen';

const PublicTotemLoader = ({ type }) => {
    const { slug } = useParams();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('key');
    const [status, setStatus] = useState("Autenticando dispositivo...");
    const [error, setError] = useState(null);
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        const authenticate = async () => {
            if (!slug || !token) {
                setError("Link inválido. Slug ou chave ausentes.");
                return;
            }

            try {
                // Se já está logado (kiosk ou usuário real), renderiza direto
                const currentUser = auth.currentUser;
                if (currentUser) {
                    setAuthenticated(true);
                    return;
                }

                // 1. Chama a Cloud Function para garantir que o usuário Totem existe
                setStatus("Validando credenciais...");
                const authenticateKiosk = httpsCallable(functions, "authenticateKiosk");
                const result = await authenticateKiosk({ slug, token });
                const kioskEmail = result.data.email;

                if (!kioskEmail) {
                    throw new Error("Falha ao recuperar credencial do Totem.");
                }

                // 2. Faz o login no Firebase de forma tradicional (Email/Senha)
                setStatus("Iniciando sessão...");
                await signInWithEmailAndPassword(auth, kioskEmail, token);

                // 3. Marca como autenticado — o componente do kiosk será renderizado diretamente
                setAuthenticated(true);

            } catch (err) {
                console.error("Erro na autenticação do Totem:", err);
                setError(err.message || "Não foi possível validar este link.");
            }
        };

        authenticate();
    }, [slug, token]);

    // ═══ Erro ═══
    if (error) {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center bg-dark text-white" style={{ minHeight: "100vh" }}>
                <i className="mdi mdi-alert-circle-outline text-danger mb-3" style={{ fontSize: "64px" }}></i>
                <h3 className="fw-bold">Acesso Negado</h3>
                <p className="text-muted">{error}</p>
                <p className="small text-muted mt-5">Verifique no painel Mídias do Totem se este link não foi revogado.</p>
            </div>
        );
    }

    // ═══ Autenticado — renderiza o componente do Kiosk diretamente ═══
    if (authenticated) {
        if (type === "tv") return <TVDisplay />;
        if (type === "print") return <WorkoutPrintScreen />;
        return <KioskPage />;
    }

    // ═══ Loading ═══
    return (
        <div className="d-flex flex-column justify-content-center align-items-center bg-dark text-white" style={{ minHeight: "100vh" }}>
            <Spinner color="light" style={{ width: "3rem", height: "3rem" }} className="mb-4" />
            <h4 className="fw-medium">{status}</h4>
            <p className="text-white-50 mt-2 small">Conectando ao sistema...</p>
        </div>
    );
};

export default PublicTotemLoader;
